﻿import { IDonorLogistics } from './donor-logistics';
import { IGpsAutomation } from './gps-automation';
import { IMoveTrackerStatus } from './move-tracker-status';

export interface IMoveTracker {
    clusterId: number;
    chainId: number;
    clusterNumber: number;
    positionNumber: number;
    donorId: number;
    donorAlias: string;
    donorCenter: string;
    donorCenterId: number;
    donorCenterTimezone: string;
    donorCenterLatitude: number;
    donorCenterLongitude: number;
    rdnCenterId: number;
    rdnCenterTimezone: string;
    rdnCenterAlias: string;
    rdnCenterLatitude: number;
    rdnCenterLongitude: number;
    recipientId: number;
    recipientAlias: string;
    recipientCenter: string;
    recipientCenterId: number;
    recipientCenterTimezone: string;
    recipientCenterLatitude: number;
    recipientCenterLongitude: number;
    kidneyPickup: string;
    kidneyPickupLocal: string;
    kidneyArrival: string;
    kidneyArrivalLocal: string;
    courier: string;
    mapLink: string;
    notes: string;
    logistics: IDonorLogistics;
    gpsAutomation: IGpsAutomation;
    pickup: IMoveTrackerStatus;
    flightDeparture1: IMoveTrackerStatus;
    flightDeparture2: IMoveTrackerStatus;
    airlineRecovery: IMoveTrackerStatus;
    delivery: IMoveTrackerStatus;
    activeLogisticsPlan: string;
    dutyOfficer: string;
    dutyOfficerName: string;
    dutyOfficerEmail: string;
    dutyOfficerPhone: string;
    activeAlert: boolean;
}
